/* src/app/chase-transaction-logs/chase-transaction-logs.component.css */
.searchbox {
  width: 400px !important;
  margin-bottom: 10px !important;
  margin-left: 5px !important;
  height: 33px !important;
  border: 1px solid #dedede;
  background: #fff;
}
.searchbox::placeholder {
  color: #000 !important;
  padding-left: 10px;
}
/*# sourceMappingURL=chase-transaction-logs.component.css.map */
